<template>
  <div class="card-container">
    <div class="card-planos">
      <div class="card-planos-btns text-center">
        <!-- <b-button
          class="btn-planos"
          @click="pesquisarTabelaPlano(uniflexPersonal)"
        >
          {{ uniflexPersonal.nome }}
        </b-button>
        <b-button class="btn-planos" @click="pesquisarTabelaPlano(unimedLight)">
          {{ unimedLight.nome }}
        </b-button> -->
        <!-- <b-button
          class="btn-planos"
          @click="pesquisarTabelaPlano(unimedUfsc)"
          v-if="isShowButtonUFSC"
        >
          {{ unimedUfsc.nome }}
        </b-button> -->
        <div class="container-principal">
          <div class="card-formulario">
            <div class="campo-grupo">
              <label class="label-input">Carteirinha Unimed</label>
              <div class="input-container-flex">
                <input
                  v-model="cardNumber"
                  type="text"
                  class="input-texto"
                  maxlength="21"
                />
                <button
                  type="submit"
                  class="botao-verde"
                  :disabled="!isCardValid"
                  :class="{ 'botao-desabilitado': !isCardValid }"
                  @click="pesquisarTabelaPlano(cardNumber)"
                >
                  Exibir minha tabela
                </button>
              </div>
              <p
                v-if="cardNumber.length > 0 && !isCardValid"
                class="erro-mensagem"
              >
                O número da carteirinha deve ter 22 caracteres.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShowButtonUFSC: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uniflexPersonal: {
        nome: "Uniflex e Personal",
        tabela: "UNIFLEX/PERSONAL",
      },
      unimedLight: {
        nome: "Unimed Light",
        tabela: "LIGHT",
      },
      unimedUfsc: {
        nome: "Unimed UFSC",
        tabela: "UFSC",
      },
      cardNumber: "",
    };
  },
  watch: {
    cardNumber(value) {
      let v = value.replace(/\D/g, "");

      if (v.length > 4) v = v.replace(/^(\d{4})(\d)/, "$1.$2");
      if (v.length > 9) v = v.replace(/^(\d{4})\.(\d{4})(\d)/, "$1.$2.$3");
      if (v.length > 16)
        v = v.replace(/^(\d{4})\.(\d{4})\.(\d{6})(\d)/, "$1.$2.$3.$4");
      if (v.length > 19)
        v = v.replace(
          /^(\d{4})\.(\d{4})\.(\d{6})\.(\d{2})(\d)/,
          "$1.$2.$3.$4-$5"
        );

      this.cardNumber = v.substring(0, 21);
    },
  },
  methods: {
    pesquisarTabelaPlano(parametro) {
      localStorage.setItem("Carteirinha", JSON.stringify(parametro));
      localStorage.setItem("Plano", JSON.stringify(parametro));

      let tipoPessoa = "pf";
      if (this.isShowButtonUFSC) tipoPessoa = "pj";

      localStorage.setItem("TipoPessoa", JSON.stringify(tipoPessoa));

      this.$router.push({ name: "Tabelas" });
    },
    handleSubmit() {
      if (this.isCardValid) {
        const cleanNumber = this.cardNumber.replace(/\D/g, "");
      }
    },
  },
  computed: {
    isCardValid() {
      return this.cardNumber.length === 21;
    },
  },
};
</script>

<style scoped>
.card-planos {
  padding: 50px 0;
}

.btn-planos {
  font-family: UnimedSans-Bold;
  width: 190px;
  height: 40px;
  margin: 15px 25px;
  border-radius: 6px;
  border: 1px solid #439763;
  background-color: #439763;
  opacity: 1;
}

.btn-planos:hover {
  background-color: #2d6542;
  border-color: #2d6542;
}

.container-principal {
  font-family: UnimedSans-Bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-formulario {
  padding: 40px;
  width: 100%;
  max-width: 680px;
}

.campo-grupo {
  display: flex;
  flex-direction: column;
}

.label-input {
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
  font-size: 14px;
  text-align: left;
}

.input-container-flex {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

.input-texto {
  flex: 1;
  padding: 12px 15px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 16px;
  outline: none;
}

.botao-verde {
  background-color: #00995d;
  color: white;
  border: none;
  padding: 0 25px;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.botao-verde:hover {
  background-color: #007f4e;
}

.botao-desabilitado {
  background-color: #ccc !important;
  cursor: not-allowed;
  opacity: 0.7;
}

.erro-mensagem {
  color: #d9534f;
  font-size: 12px;
  margin-top: 5px;
}
</style>
